/**
 * @file
 *
 * This is our initial barebones mapping of english snippets
 * to the equivalent spanish, to be shared between front and back
 * end libraries.
 *
 * Future iterations may see increased complexity, such as templating,
 * but until then, we're keeping it remedial.
 *
 * Translations are being managed in a Google Sheet:
 * See https://docs.google.com/spreadsheets/d/1SOguSKv3U4EMvSTKZyeDzHlJCXDnjziUKITvHBPfW2g/edit?usp=sharing
 * Regex: :%s/^\(.\+\)\t\(.\+\)\t\(.\+\)/'\1': '\2', \/\/ \3/
 */

export default {
  // Five Star Text
  'Great! Would you mind rating the app?': 'Great! Would you mind rating the app?',
  'No Thanks': 'No Thanks',
  'Rate the App': 'Rate the App',
  'Write Feedback': 'Write Feedback',
  Send: 'Send',
  'Thank you for your feedback!': 'Thank you for your feedback!',
  "What's the top reason you're not enjoying": "What's the top reason you're not enjoying",
  'Do you enjoy news from': 'Do you enjoy news from',
  "No, I don't": "No, I don't",
  'Yes, I like it': 'Yes, I like it',
  "Whoops, you didn't write anything!": "Whoops, you didn't write anything!",
  'Enjoying news from': 'Enjoying news from',
  'Not Really': 'Not Really',
  'Yes!': 'Yes!',
  'Add your comments here': 'Añada tus comentarios aquí', // General
  'Add your email here': 'Ingresa tu correo electrónico aquí', // General
  'Add your feedback here': 'Agrega tus comentarios aquí',
  Advertisement: 'Anuncio', // Ads
  Aquarius: 'Acuario', // Horoscopes
  'CHECK THE WEATHER': 'COMPROBAR EL TIEMPO', // Weather
  'CHECK WEATHER': 'VERIFICAR EL TIEMPO', // Weather
  'CHECKOUT DEALS': 'OFERTAS DE PAGO', // Deals
  'CHECKOUT EVENTS': 'EVENTOS DE COMPROBACIÓN', // Events
  Cancel: 'Cancelar', // General
  Cancer: 'Cáncer', // Horoscopes
  Capricorn: 'Capricornio', // Horoscopes
  Celebrities: 'Famosos', // General
  'Check The Weather to Make Plans!': '¡Comprueba el clima antes de hacer planes!', // Weather
  'Check out my fortune on': 'Mira mi fortuna en', // Fortune
  'Check out my horoscope on': 'Mira mi horóscopo en', // Horoscopes
  'Check out your fortune on': 'Encuentra tu fortuna en', // Fortune
  'Check out your horoscope on': 'Encuentra tu horóscopo en', // Horoscopes
  Deals: 'Ofertas', // Deals
  'Discover Fun Around Town!': '¡Descubre eventos divertidos cerca de ti!', // Events
  "Don't Miss Out On Local Deals!": '¡No te pierdas las ofertas locales!', // Deals
  Feedback: 'Comentarios', // General
  'Find new events nearby through Eventful': 'Encuentra nuevos eventos cercanos con Eventful', // Events
  'Fortune Cookie': 'Galleta de la Fortuna', // Fortune
  'Fortune Cookie: Press Enter to reveal your fortune':
    "Galleta de la fortuna: presione 'Intro' para revelar su fortuna", // Fortune
  'Click to reset the fortune cookie.': 'Click to reset the fortune cookie.',
  'Reveal your fortune': 'Revelar tu fortuna',
  'Share your fortune!': 'Comparte tu fortuna!',
  Fotoscapes: 'Fotos', // Fotoscapes
  Games: 'Juegos', // General
  Gemini: 'Géminis', // Horoscopes
  'Give Feedback': 'Dar opinion',
  'Go to Video': 'Ir al video', // Videos
  Horoscopes: 'Horóscopos', // Horoscopes
  Lifestyle: 'Estilo de Vida', // Lifestyle
  'Local deals by Groupon - Start saving now!':
    'Ofertas locales de Groupon - ¡Comience a ahorrar ahora!', // Deals
  'Local weather forecast from weatherbug.com': 'Pronóstico del tiempo local de accuweather.com', // Weather
  Local: 'Locales', // Local
  'My fortune was': 'Mi fortuna fue', // Fortune
  News: 'Noticias', // News
  Pisces: 'Piscis', // Horoscopes
  'Please provide us with the following:': 'Por favor proporciónenos lo siguiente',
  'Press Enter to reveal your fortune': "Presione 'Intro' para revelar su fortuna", // Fortune
  Sagittarius: 'Sagitario', // Horoscopes
  Scorpio: 'Escorpio', // Horoscopes
  'Scroll for more content': 'Desplaza hacia abajo para más contenido', // General
  Sports: 'Deportes', // Sports
  'Submit Feedback': 'Enviar Comentarios', // General
  Submit: 'Enviar', // General
  Taurus: 'Tauro', // Horoscopes
  'Video duration': 'duración del video', // Videos
  'You can get your own fortune told at': 'Puedes obtener tu propia fortuna contada en', // Fortune
  'Your Feedback': 'Tu retroalimentación',
  'Your email address so that we can contact you':
    'Su dirección de correo electrónico para que podamos contactarlo',
  aquarius: 'acuario', // Horoscopes
  browse: 'mira', // General
  cancer: 'cáncer', // Horoscopes
  capricorn: 'capricornio', // Horoscopes
  close: 'cierre', // General
  feedback: 'elimentación', // General
  gemini: 'géminis', // Horoscopes
  general: 'general', // General
  health: 'salud', // General
  horoscopes: 'horóscopos', // Horoscopes
  loading: 'cargando', // General
  look: 'mira',
  love: 'amor', // General
  money: 'dinero', // General
  pisces: 'piscis', // Horoscopes
  play: 'juega', // General
  'powered by Google': 'proveído por Google', // General
  read: 'lee', // General
  sagittarius: 'sagitario', // Horoscopes
  scorpio: 'escorpio', // Horoscopes
  search: 'buscar', // General
  share: 'compartir', // General
  sponsored: 'patrocinado', // General
  taurus: 'tauro', // Horoscopes
  today: 'hoy', // General
  watch: 've' // General
}
